import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'pme-product-benefit',
    templateUrl: './product-benefit.component.html',
    styleUrls: ['./product-benefit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProductBenefitComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() iconUrl: string;

  constructor() { }

  ngOnInit() {

  }

}
